import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 62px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 32px;
  }
`

export const CardWrapper = styled.div`
  display: flex;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const Card = styled.div`
  align-items: flex-start;
  border: 1px solid #00A687;
  border-radius: 32px;
  display: flex;
  flex: 1 100%;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 32px;
`

export const Title = styled.h6`
  color: #007D55;
`

export const Content = styled.p`
  font-family: Source Sans 3;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`

export const PrivacyPolicy = styled.div`
  background: #F5F5F5;
  border-radius: 32px;
  padding: 32px;

  a {
    color: #00C0DA;
    display: inline-block;
    font-family: Source Sans 3;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 16px;
    text-align: left;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  p {
    display: inline-block;
    font-family: Source Sans 3;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
`

export const InfoContainer = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const LogoContainer = styled.div`
  flex: 1 50%;
`

export const ContactContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1 50%;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
`

export const ContactItemContainer = styled.div`
  align-items: center;
  color: #084F43;
  display: flex;
  font-family: Source Sans 3;
  font-weight: 600;
  font-size: 14px;
  gap: 8px;
  line-height: 140%;
`

export const SocialContainer = styled.div`
  align-items: center;
  display: flex;
`

export const Social = styled.a``

export const Logo = styled.img``

export const LogoGT7Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`

export const Phone = styled.a`
  border: 1.5px solid #00A988;
  border-radius: 100000px;
  color: #00A988;
  display: inline-block;
  font-family: 'Source Sans 3';
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  margin-left: 8px;
  padding: 4px 16px;
`

export const Disclaimer = styled.div`
  color: #7E8691;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
`

export const LogoGT7 = styled.img``
